import React, { useReducer } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

import { DatePeriod, CashRegisters, filterReducer } from '../filterFragments'
import Periods from './Periods'
import { Select, DateTimePicker, Checkbox } from 'components/forms'
import { ExpandableBlocks, ContentBlock } from 'components/ContentBlock'
import Button from 'components/Button'
import Divider from 'components/Divider'
import { CardsRow, CardCol } from '../filterFragments/styled'
import { FormRow, FormCol } from 'style/styled'
import { listCashRegisters } from 'gql/query'
import { useQuery } from 'components/graphql'

const Filter = ({ onFilter, creditVal, onChangeCredit }) => {
	const { data } = useQuery(listCashRegisters, { fetchPolicy: 'cache-first' })
	const [filter, dispatchFilter] = useReducer(filterReducer, {
		from: moment().utc().startOf('day').toISOString(),
		to: moment().utc().endOf('day').toISOString(),
		intervalList: [],
		timeCheck: false,
		timeStart: moment().utc().startOf('day').format('HH:mm:ss.SSSZ'),
		timeEnd: moment().utc().endOf('day').format('HH:mm:ss.SSSZ'),
		interval: 60,
		cashRegisterIds: data?.listCashRegisters?.map(({ id }) => id) || []
	})

	const handleFilter = () => {
		const { to, from, intervalList, ...filterVals } = filter
		let queryParams = filterVals
		if(intervalList.length) {
			queryParams.intervalList = intervalList
		} else {
			queryParams.to = moment(to).utc().add(1, 'days').startOf('day')
			queryParams.from = from
		}
		onFilter(queryParams)
	}

	const { from, to, intervalList, timeCheck, timeStart, timeEnd, interval, cashRegisterIds } = filter
	const isPeriod = moment(to).diff(moment(from), 'days') >= 1
	const [t] = useTranslation()
	const dateLabel = t('statistic_section.strings.date')
	return(
		<>
			<FormRow>
				<FormCol xs {...!isPeriod && { narrow: true }}>
					<DatePeriod
						value={{ fromDateTime: from, toDateTime: to }}
						onChange={value => dispatchFilter({ value, type: 'datePeriod' })}
						label={dateLabel}
						labelPeriod={{
							from: `${dateLabel} ${t('common.strings.from').toLowerCase()}`,
							to: `${dateLabel} ${t('common.strings.to').toLowerCase()}`
						}}
						maxDate={moment().utc()}
						disabled={!!intervalList.length}
					/>
					<Checkbox
						noForm
						label={t('common.fields.time')}
						value={timeCheck}
						onChange={e => dispatchFilter({ value: e.target.checked, type: 'timeCheck' })}
					/>
				</FormCol>
				<FormCol xs>
					<Select
						value={interval}
						onChange={({ value }) => dispatchFilter({ value, type: 'interval' })}
						label={t('common.fields.time')}
						options={[
							{ value: 60, label: t('common.dates.minute_count', { count: 60 }) },
							{ value: 30, label: t('common.dates.minute_count', { count: 30 }) },
							{ value: 15, label: t('common.dates.minute_count', { count: 15 }) },
							{ value: 5, label: t('common.dates.minute_count', { count: 5 }) }
						]}
						disabled={!timeCheck}
						noForm
					/>
					<Checkbox
						value={creditVal}
						onChange={e => onChangeCredit(e.target.checked)}
						label={t('common.strings.credit_customer')}
					/>
				</FormCol>
				<FormCol xs>
					<DateTimePicker
						noForm
						value={{ from: timeStart, to: timeEnd }}
						onChange={value => dispatchFilter({ value, type: 'timePeriod' })}
						picker='time'
						interval
						label={{ from: t('common.strings.from'), to: t('common.strings.to') }}
						addDateToTime={false}
						disabled={!timeCheck}
					/>
				</FormCol>
			</FormRow>
			<ExpandableBlocks nested>
				<ContentBlock label={t('statistic_section.strings.filter')} startExpanded>
					<CardsRow>
						<CardCol>
							<Periods
								value={intervalList}
								onChange={value => dispatchFilter({ value, type: 'intervalList' })}
							/>
						</CardCol>
						<CardCol>
							<CashRegisters
								value={cashRegisterIds}
								onChange={value => dispatchFilter({ value, type: 'cashRegisterIds' })}
							/>
						</CardCol>
					</CardsRow>
				</ContentBlock>
			</ExpandableBlocks>
			<Divider />
			<Button text={t('common.buttons.calculate')} onClick={handleFilter} />
		</>
	)
}

export default Filter
